module.exports = __webpack_public_path__ + "img/koffee_logo_primary.edde40a6.png";